import { DraggableItemType, DraggableItemTypes } from 'containers/DndStackContainer/enums/draggable-item-type.enum';

export const isWidgetType = (
  value: DraggableItemTypes,
): boolean => DraggableItemType.PageConfigWidget === value;
